import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateAssumptions } from "../../../../store/modules/waterfall/actions";
import { primary } from "../../../../assets/colorPallet";

function DistributionsSchedule({
  dealType,
  assumptions,
  dispatchGenerateAssumptions,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateAssumptions(dealType);
  }, []);

  return (
    <div>
      {assumptions && (
        <div className="pt-20">

          <div className="flex items-center font-semibold text-center text-white mt-5 mb-10 pb-5">
            <div
              style={{ backgroundColor: primary, minWidth: assumptions.basis === "MULTI" ? "106em" : "94em" }}
              className="absolute left-0 w-full h-12 z-10"
            />
            <div className="z-20 text-center" style={{ width: "18em", minWidth: "18em" }}>Tranche</div>
            <div className="z-20 text-center" style={{ width: "12em", minWidth: "12em" }}>
            {assumptions.basis === "COC" ? "Cash on Cash Return" : "Internal Rate of Return"}
            </div>
            {assumptions.basis === "MULTI" && <div className="z-20 text-center" style={{ width: "12em", minWidth: "12em" }}>Equity Multiple</div>}
            <div className="z-20 text-center" style={{ width: "12em", minWidth: "12em" }}>Tranche GP Split</div>
            <div className="z-20 text-center" style={{ width: "12em", minWidth: "12em" }}>Tranche LP Split</div>
            <div className="z-20 text-center" style={{ width: "12em", minWidth: "12em" }}>Catch-Up Percentage</div>
            <div className="z-20 text-center" style={{ width: "12em", minWidth: "12em" }}>Catch-Up GP Split</div>
            <div className="z-20 text-center" style={{ width: "12em", minWidth: "12em" }}>Catch-Up LP Split</div>
          </div>

          {assumptions.proceeds === "PPS" ?
            assumptions.schedule.map((sche, index) => (
              sche.tranche &&
              (<div className="flex items-center mt-10" >
                <div className="text-center" style={{ minWidth: "18em" }}>Tranche {index + 1}</div>
                <div className="text-center" style={{ minWidth: "12em" }}>{sche.hurdle}%</div>
                {assumptions.basis === "MULTI" && <div className="text-center" style={{ minWidth: "12em" }}>{sche.multiHurdle}x</div>}
                <div className="text-center" style={{ minWidth: "12em" }}>{sche.trancheGPSplit.toFixed(2)}%</div>
                <div className="text-center" style={{ minWidth: "12em" }}>{sche.trancheLPSplit.toFixed(2)}%</div>
                <div className="text-center" style={{ minWidth: "12em" }}>{sche.catchUp ? sche.catchUpPercent + "%" : "--"}</div>
                <div className="text-center" style={{ minWidth: "12em" }}>{sche.catchUp ? sche.catchUpGPSplit + "%" : "--"}</div>
                <div className="text-center" style={{ minWidth: "12em" }}>{sche.catchUp ? sche.catchUpLPSplit + "%" : "--"}</div>
              </div>)
            ))
            :
            (<div className="text-center mt-20 text-4xl font-bold">Pro&nbsp;&nbsp;&nbsp;Rata</div>)
          }

        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  assumptions: state.waterfall.assumptions,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateAssumptions(dealType) {
    await dispatch(generateAssumptions(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DistributionsSchedule);
